import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const bestOnlineReviewsStylesIN: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_BODY: 'bg-white',
  COMMONS_APPBAR_BG: 'bg-[#FF6B3C]',
  COMMONS_APPBAR_TEXT: 'text-white',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-white [&>path]:stroke-white',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-white',
  COMMONS_FOOTER_BG: 'bg-[#FF6B3C]',
  COMMONS_FOOTER_TEXT: 'text-white',
  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-white',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-[#6C9EFF] [&>svg>path]:stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: 'shadow-xl',

  HOMEPAGE_HEADER_BG: 'bg-[#F4F6FA]',
  HOMEPAGE_HEADER_TEXT: 'text-black',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#FF6B3C]',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#6C9EFF]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-black',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-black',

  HOMEPAGE_TOPRATED_BUTTON: 'border-[#6C9EFF] hover:border-[#6C9EFF] hover:bg-[#6C9EFF] hover:text-white text-black',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#6C9EFF]',

  HOMEPAGE_RANK_BANNER_BG: 'bg-[#FF6B3C]',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#FF6B3C]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#6C9EFF]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#20233A] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#20233A] text-[#20233A] [&>svg>path]:stroke-[#20233A] [&>svg>g>path]:stroke-[#20233A] [&>svg>path]:fill-[#20233A] [&>svg>g>path]:fill-[#20233A]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#20233A]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#FF6B3C]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#F4F6FA]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#6C9EFF]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#F4F6FA]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#FF6B3C] [&>.explore-icon-fill]:!fill-[#F4F6FA] [&>g>.explore-icon-fill]:!fill-[#F4F6FA]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#F4F6FA] [&>.vector-top>path]:fill-[#FF6B3C] [&>.vector-bottom>path]:fill-[#FF6B3C]',

  LISTPAGE_HERO_IMAGE_HEADER_TEXT: 'text-black',

  LISTPAGE_USER_VALUE_BADGE: 'text-[#FF6B3C] [&>div>svg>path]:fill-[#FF6B3C] bg-[#F4F6FA]',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: ' text-[#FF6B3C]',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#6C9EFF]',
  LISTPAGE_BADGE_SPONSORED_TEXT: '!text-[#ffff]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-[#FF6B3C]',
  LISTPAGE_BADGE_WINNER_DIVIDER: '!divide-[#FF6B3C]',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-[#FF6B3C]',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '!divide-[#FF6B3C]',

  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#6C9EFF]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-[#FF6B3C]',

  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-black',

  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#FF6B3C]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: ' stroke-[#FF6B3C]',

  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#F4F6FA]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-black',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:fill-black',

  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#FF6B3C]',

  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#20233A] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#20233A] text-[#20233A] [&>svg>path]:stroke-[#20233A] [&>svg>g>path]:stroke-[#20233A] [&>svg>path]:fill-[#20233A] [&>svg>g>path]:fill-[#20233A]',
  LISTPAGE_BUTTON_LINK: 'text-[#20233A]',
  LISTPAGE_ANCHOR_LINK: 'text-[#20233A]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#20233A]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#20233A]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#20233A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#20233A] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#20233A] text-[#20233A] [&>svg>path]:stroke-[#20233A] [&>svg>g>path]:stroke-[#20233A] [&>svg>path]:fill-[#20233A] [&>svg>g>path]:fill-[#20233A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#20233A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#20233A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#20233A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#20233A]',

  LISTPAGE_SPONSORED_CARD_BORDER: 'tablet:border-[#6C9EFF]',

  LISTPAGE_TOP_PICKS_SPECS_CARD_BORDER: 'tablet:border tablet:border-gray-400',

  LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT: 'text-black',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER: 'border-[#20233A]',

  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#F4F6FA] [&>.vector-top>path]:fill-[#FF6B3C] [&>.vector-bottom>path]:fill-[#FF6B3C]',

  LISTPAGE_WIDGETS_RELATED_PRODUCTS_BG: 'bg-neutral-100',

  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#F4F6FA] [&>circle]:stroke-[#FF6B3C] [&>path]:fill-[#FF6B3C]',

  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#F4F6FA]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-[#20233A]',

  LISTPAGE_WIDGETS_SORT_BY_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:bg-[#F4F6FA] data-[focus]:text-[#20233A]',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'bg-[#F4F6FA]',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#20233A]',

  LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SHAREMENU_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_DISCLAIMER_INFO_BUTTON: 'bg-[#F4F4F5]',

  LISTPAGE_SECTIONS_EXPLORE_BANNER_BG: 'bg-amber-200',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_TEXT: 'text-black',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#FBBF24] [&>.explore-icon-fill]:!fill-[#92400E] [&>g>.explore-icon-fill]:!fill-[#92400E]',

  UTILS_MAIN_CONTAINER: 'content-container',
}
